import type { AiCategory } from '@b4b/shared';

export interface FeedParams {
  filter: 'unread' | 'all';
  category?: string | undefined;
  tag?: string | undefined;
  topic?: AiCategory | undefined;
}

/** Build the feed URL for a set of filters (omits defaults so `/` stays clean). */
export function feedUrl(params: FeedParams): string {
  const search = new URLSearchParams();
  if (params.filter === 'all') search.set('filter', 'all');
  if (params.category) search.set('cat', params.category);
  if (params.tag) search.set('tag', params.tag);
  if (params.topic) search.set('topic', params.topic);
  const query = search.toString();
  return query ? `/?${query}` : '/';
}
